module.exports = __webpack_public_path__ + "static/img/planning5.dfa4cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/planning5.png
// module id = /qjN
// module chunks = 1